export default __webpack_public_path__ + "static/media/check-green.b406d3db.svg";